import { render } from "./AudienceExpansionOptions.vue?vue&type=template&id=45edb81e&scoped=true"
import script from "./AudienceExpansionOptions.vue?vue&type=script&lang=js"
export * from "./AudienceExpansionOptions.vue?vue&type=script&lang=js"

import "./AudienceExpansionOptions.vue?vue&type=style&index=0&id=45edb81e&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45edb81e"]])

export default __exports__